import { FDateFormat, fDate } from '../../../utils/formatTime';
import Label from '../../../components/label/Label';
import { priorityColorByValue, statusColorByStatusMapped } from './mapColorHelpers';
import { TaskGeneral } from '../../../models/owner-portal/taskGeneral';

// ----------------------------------------------------------------------
export type confirmActionT = 'edit' | 'cancel' | 'drop' | 'edit_confirm';
type Props = {
  task: TaskGeneral;
};
// ----------------------------------------------------------------------

export default function TaskDetails({ task }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h5 className="text-xl font-semibold">{task.title}</h5>
        {task.related_name && (
          <p className="text-base text-muted-foreground">{task.related_name}</p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Priority */}
        <div className="flex flex-col gap-1">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Priority</span>
          <Label variant="soft" color={priorityColorByValue(task.priority_value)} className="w-fit">
            {task.priority}
          </Label>
        </div>
        {/* Status */}
        <div className="flex flex-col gap-1">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Status</span>
          <Label
            variant="soft"
            color={statusColorByStatusMapped(task.status_mapped)}
            className="w-fit"
          >
            {task.status_mapped}
          </Label>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Type */}
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Type</span>
          <span className="text-base">{task.type || '-'}</span>
        </div>
        {/* Sub Type */}
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Sub Type</span>
          <span className="text-base">{task.sub_type || '-'}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Assignee */}
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Assigned To</span>
          <span className="text-base">{task.assignee_name}</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Created On */}
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Created On</span>
          <span className="text-base">
            {fDate(task.created_at_ISO, FDateFormat.localized_us_numeric_month_day_year)}
          </span>
        </div>
        {/* Due Date */}
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Due Date</span>
          <span className="text-base">
            {fDate(task.dueDate, FDateFormat.localized_us_numeric_month_day_year)}
          </span>
        </div>
      </div>

      {task.start_time && (
        <div className="grid grid-cols-2 gap-4">
          {/* Started */}
          <div className="flex flex-col">
            <span className="text-xs uppercase tracking-wide text-muted-foreground">Started</span>
            <span className="text-base">
              {fDate(task.start_time, FDateFormat.localized_us_numeric_month_day_year)}
            </span>
          </div>
          {/* Completed */}
          <div className="flex flex-col">
            <span className="text-xs uppercase tracking-wide text-muted-foreground">Completed</span>
            <span className="text-base">
              {task.completed_time
                ? fDate(task.completed_time, FDateFormat.localized_us_numeric_month_day_year)
                : '-'}
            </span>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 gap-4">
        <div className="flex flex-col">
          <span className="text-xs uppercase tracking-wide text-muted-foreground">Updated</span>
          <span className="text-base">
            {fDate(task.last_modified_date_ISO, FDateFormat.localized_date_time_full)}
          </span>
        </div>
      </div>
    </div>
  );
}
